<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/7EMNY1/media/FC-9781645368540.jpg?1685014435064" alt="This image is the cover for the book Vincent's Crazy Go-Kart Race"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Vincent's Crazy Go-Kart Race
      </h1>
      <p class="bookDescription body article font2">
        <p>There is nothing more exciting than watching a go-kart race. That's what Vincent and his parrot, Olli, believe. Every time there's a go-kart race on television, the two go absolutely mad and tear the living room apart in their excitement. Then, Vincent is suddenly given the chance to do more than just watch the races. A local club is hosting a go-kart race, and Vincent can't wait to sign up. There's just one problem, Vincent's mum gives him a set of rules he must follow if he wants to join the racers. The first is to find someone who can train him! With Olli and his other friends along for the ride, Vincent sets out on a quest and ends up discovering something special about his family. As Vincent works hard to make his dream come true, he learns the value of perseverance in this fast-paced adventure.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Lakshan Chaturi
      </h2>
      
      <p class="authorDescription body article">Lakshan Chaturi is a former primary school teacher. She received her bachelor's and master's degrees in education as well as a certificate in children's writing. Chaturi served for many years as a curriculum coordinator and a mentor for incoming teachers. She was honored with a Teacher Excellence Award for level 1 and level 11. She served on the Board of Teacher Education with the University of Northern Territory for several years. When Lakshan retired, she focused her attention on writing children's books.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?2922e8aa